/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClockHistoryEdit = (props: Props) => (
  <Icon viewBox="0 0 25 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="m5.154 10.432 1.139-1.14 1.414 1.415L4 14.414.293 10.707l1.414-1.414 1.38 1.38C3.737 5.777 7.927 2 13 2c4.76 0 8.742 3.325 9.752 7.779l-1.95.442a8.003 8.003 0 0 0-15.648.211zM12 6h2v5.586l1.707 1.707-1.414 1.414L12 12.414zm9.164 5.594 3.257 3.18L17.234 22H14v-3.236zm.017 2.812L16 19.591V20h.402l5.177-5.205zM5.888 15.668a8.004 8.004 0 0 0 6.222 4.283l-.22 1.988a10.005 10.005 0 0 1-7.778-5.352z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgClockHistoryEdit as ClockHistoryEdit };
